import React, { useState } from "react";
import {
  Modal,
  Box,
  Typography,
  IconButton,
  TextField,
  Button,
  Radio,
  RadioGroup,
  FormControlLabel,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { Formik } from "formik";
import * as Yup from "yup";
import socketService from "socket/newsocketService";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const getValidationSchema = (selected) =>
  Yup.object().shape({
    ...(selected === "Email"
      ? { subject: Yup.string().trim().required("Subject is required") }
      : {}),
    body: Yup.string().trim().required("Message is required"),
  });

const SendMessageModal = ({ visible, onClose, userData }) => {
  const [selected, setSelected] = useState("SMS");
  // console.log("userData", userData);

  return (
    <Modal open={visible} onClose={onClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: "90%",
          maxWidth: 500,
          bgcolor: "background.paper",
          borderRadius: 2,
          boxShadow: 24,
          p: 3,
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mb: 2,
          }}
        >
          <Typography variant="h6" sx={{ fontWeight: 600 }}>
            Send Message
          </Typography>
          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Box>

        <RadioGroup
          row
          value={selected}
          onChange={(e) => setSelected(e.target.value)}
          sx={{ mb: 2 }}
        >
          <FormControlLabel value="SMS" control={<Radio color="primary" />} label="SMS" />
          <FormControlLabel value="Email" control={<Radio color="primary" />} label="Email" />
        </RadioGroup>

        <Formik
          enableReinitialize
          initialValues={{ subject: "", body: "" }}
          validationSchema={getValidationSchema(selected)}
          onSubmit={(values, { resetForm }) => {
            const { subject, body } = values;
            const payload =
              selected === "SMS"
                ? {
                    isSMS: true,
                    message: body,
                    mobileNumber: userData?.userPhone,
                  }
                : {
                    isSMS: false,
                    to: userData?.userEmail,
                    subject,
                    html: body,
                  };

            // console.log("Sending send message:", payload);

            socketService.emit("sendAlertSMSOrEmail", payload);
            if (selected === "SMS") {
              toast.success(`SMS sent successfully to ${userData?.userPhone || "the user"}`);
            } else {
              toast.success(`Email sent successfully to ${userData?.userEmail || "the user"}`);
            }

            resetForm();
            onClose();
          }}
        >
          {({ handleChange, handleBlur, handleSubmit, values, errors, touched }) => (
            <form onSubmit={handleSubmit}>
              {selected === "Email" && (
                <>
                  <Typography
                    variant="body2"
                    sx={{
                      mb: 0.5,
                      color: "text.primary",
                      fontWeight: 500,
                    }}
                  >
                    Subject
                  </Typography>
                  <TextField
                    fullWidth
                    name="subject"
                    placeholder="Subject"
                    variant="outlined"
                    value={values.subject}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={touched.subject && Boolean(errors.subject)}
                    helperText={touched.subject && errors.subject}
                    size="small"
                    sx={{ mb: 2 }}
                  />
                </>
              )}

              <Typography variant="body2" sx={{ mb: 0.5, color: "text.primary", fontWeight: 500 }}>
                {selected === "SMS" ? "Message" : "Body"}
              </Typography>
              <TextField
                fullWidth
                name="body"
                placeholder={selected === "SMS" ? "Type your message" : "Type your email body"}
                multiline
                minRows={selected === "SMS" ? 4 : 6}
                variant="outlined"
                value={values.body}
                onChange={handleChange}
                onBlur={handleBlur}
                error={touched.body && Boolean(errors.body)}
                helperText={touched.body && errors.body}
                sx={{ mb: 3 }}
              />

              <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 1 }}>
                <Button
                  onClick={onClose}
                  variant="outlined"
                  sx={{
                    textTransform: "none",
                    borderColor: "#D0D0D0",
                    color: "text.primary",
                  }}
                >
                  Cancel
                </Button>

                <button className="btn btn-primary pt-2 pb-2" style={{ width: 120 }}>
                  Send
                </button>
              </Box>
            </form>
          )}
        </Formik>
      </Box>
    </Modal>
  );
};

export default SendMessageModal;
